<template>
  <div class="row">&nbsp;</div>
  <div v-if="this.user.role_name === 'system' || this.user.role_name === 'systemadmin' || this.user.role_name === 'administrator' || this.user.role_name === 'supper-vip'">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="row">
            <!-- <WelcomeCard /> -->
            <div class="col-xxl-12">
              <div class="row widget-grid">
                <div class="card profile-box">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body">
                        <div class="greeting-user">
                          <h4 class="f-w-600 mb-0">
                            <vue-feather
                              type="server"
                              size="25"
                            ></vue-feather>
                            Coupon
                          </h4>
                          <p>&nbsp;</p>
                          <p>&nbsp;</p>
                        </div>
                      </div>
                    </div>
                    <div class="cartoon">
                      <img
                        class="img-fluid"
                        src="@/assets/images/dashboard/cartoon.svg"
                        alt="vector women with leptop"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12" v-if="this.page_permission === 'Y'">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <form @submit.prevent="create_event" class="needs-validation">
                  <div class="col-sm-12">
                  <b>Coupon system: </b>&nbsp;&nbsp;
                <div class="form-check form-check-inline">
                   <input class="form-check-input" @change.prevent="update_event_coupon" v-model="is_enable_coupon_system" checked required type="radio"
                    name="inlineRadioOptions" id="inlineRadio1" value="Y">
                  <label class="form-check-label" for="inlineRadio1">
                    Enable
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" @change.prevent="update_event_coupon" v-model="is_enable_coupon_system" type="radio" required name="inlineRadioOptions"
                    id="inlineRadio2" value="N">
                  <label class="form-check-label" for="inlineRadio2">
                    Disable
                  </label>
                </div>
                </div>
              </form>
            </div>
          </div>

          
          </div>

          <div class="card" v-if="this.is_enable_coupon_system ==='Y'">
          <div class="card-body">
            <div class="row">
              <form @submit.prevent="generate_coupon" class="needs-validation">
                  <div class="col-sm-12">
                  <b>Generate Coupon </b>
                  <hr>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3 ">
                        <span class="input-group-text" id="basic-addon1">Coupon Unit</span>
                        <input type="number" class="form-control" min="0" max="100" v-model="coupon_discount_unit" placeholder="10"  required  >
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3 ">
                        <span class="input-group-text" id="basic-addon2">Coupon discount percent(%)</span>
                        <input type="text" class="form-control" minlength="5" maxlength="5" v-model="coupon_discount_percent" placeholder="37.4"  required  >
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon3">Discount type</span>
                        <select disabled class="form-select" required v-model="coupon_discount_type"  id="floatingSelect">
                          <option value="PERCENTAGE">PERCENTAGE</option>
                          <option value="FIXPRICE">FIXPRICE</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6">
                      <div class="input-group mb-3">
                        <span class="input-group-text"  id="basic-addon4" >Discount prefix(if any)</span>
                        <input type="text" class="form-control" minlength="3" maxlength="3" v-model="coupon_discount_prefix" placeholder="spi"   >
                      </div>
                    </div>

                    
                    <div class="row">
                      <div class="d-flex justify-content-center">
                        <button type="submit" style="cursor: pointer"
                          class="btn btn-primary btn-lg col-6">Generate coupon</button>&nbsp;
                        <button  type="reset" @click.prevent="clear" style="cursor: pointer" class="btn btn-primary btn-lg" > Clear </button> 
                      </div>
                  </div>


                </div>
              </form>
            </div>
          </div>
          </div>

        <div class="card" v-if="this.is_enable_coupon_system ==='Y'">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
            <div class="table-responsive-sm currency-table">
              <table class="table">
                <thead>
                  <tr>
                    <th class="f-light" style="text-align: center">No.</th>
                    <th class="f-light" style="text-align: center">ID</th>
                    <th class="f-light" style="text-align: center">Code</th>
                    <th class="f-light" style="text-align: center">Description</th>
                    <th class="f-light" style="text-align: center">Discount</th>
                    <th class="f-light" style="text-align: center">Unit</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading === 'Y' &&  this.conpon_obj.length === 0" >
                  <tr>
                    <td colspan="10">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 30px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="conpon_obj.length !== 0">
                  <tr v-for="(item, index) in conpon_obj"
                      :key="item.id"
                      :class="{ 'table-danger': item.unit == 0 }">
                    <td style="text-align: center">{{ index + 1 }}</td>
                    <td style="text-align: center">{{ item.id }}</td>
                    <td style="text-align: center">{{ item.code }}</td>
                    <td style="text-align: center">{{ item.description }}</td>
                    <td style="text-align: center">{{ item.discount }}</td>
                    <td style="text-align: center">{{ item.unit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
              </div>
            </div>
          </div>

          
          </div>
        </div>
        
         <div v-if="this.page_permission === 'N'">
          <div class="d-flex justify-content-center">this page is not authorized</div>
        </div>

      </div>
    </div>
  </div>
  <div v-if="this.user.role_name === 'photographer'">
    <div class="d-flex justify-content-center">this page is not authorized</div>
  </div>
</template>
<style scoped>
.red-row {
  background-color: #f8d7da !important;
  color: #721c24 !important;
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      user: {},
      token: localStorage.getItem("jwt"),
      is_enable_coupon_system: null,
      conpon_obj: [],

      coupon_discount_unit: null,
      coupon_discount_percent: null,
      coupon_discount_type: "PERCENTAGE",
      coupon_discount_prefix: "",
      page_permission: null,
      event_coupon_obj: {}

    };
  },
  async created(){
    this.token = localStorage.getItem("jwt")
  },
  async mounted() {
    try {
      this.user = JSON.parse(localStorage.getItem("user"));

      await this.checkpermision();
      if(this.page_permission === 'Y'){
        await this.getEventCoupon()
        this.get_coupon()
      }

    } catch (error) {
      alert("An error has occurred. Please contact the system administrator.");
    }
  },
  methods: {
    async clear(){
      this.get_coupon()
    },
    async generate_coupon(){
      let data = {
        coupon_discount_unit: this.coupon_discount_unit,
        coupon_discount_percent: this.coupon_discount_percent,
        coupon_discount_type: this.coupon_discount_type,
        coupon_discount_prefix: this.coupon_discount_prefix,
        event_key: this.$route.params.q,
      };
      
      const headers = { 
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/generate-coupon",data, { headers } );
      if (response.data.status === "success") {
          alert(response.data.message)
          this.get_coupon()
      } else {
        alert("Error pls contact admin!");
      }
    }, 
    async update_event_coupon(){
      let data = {
        event_key: this.$route.params.q,
        is_enable_coupon_system: this.is_enable_coupon_system
      };
      
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event-coupon",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        
      } else {
        alert("An error has occurred. Please contact the system administrator.");
      }
    }, 
    async getEventCoupon(){
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/partner/event",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.event_coupon_obj = response.data.body
        this.is_enable_coupon_system = this.event_coupon_obj[0].is_coupon
      } else {
        alert("An error has occurred. Please contact the system administrator.");
      }
    },  
    async checkpermision(){
      try {
        let data = {
          event_key: this.$route.params.q,
        };
        const headers = {
          'Authorization': 'Bearer ' + this.token
        };
        const response = await axios.post("/v1/partner/permission", data,{
          headers
        });
        if (response.data.status === "success") {
          let bodyPermission = JSON.parse(JSON.stringify(response.data.body));
          this.page_permission = bodyPermission.permission

          this.user = JSON.parse(localStorage.getItem('user'))

        if(this.page_permission ==='Y'){
            ///

        }

        }else{
          alert("permission is not recognized by admin")
        }
        } catch (error) {
        alert("login An error has occurred. Please contact the system administrator.")
        //this.$router.push({ path: "/auth/login" });
      }
    },  
    async get_coupon(){

      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      let data = {
        event_key: this.$route.params.q,
      };
      const response = await axios.post(
        "v1/utils/coupons",
        data,
        {
          headers
        }
      );
      //console.log("response::::",response)
      if (response.data.status === "success") {
        this.conpon_obj = response.data.body
      }
    },
  },
};
</script>
